// extracted by mini-css-extract-plugin
export default {"directoryBoxRow":"AZGgS","directoryItemName":"L58kT","totalCount":"GOmBa"};